const CATEGORY = {
  All: { value: "all", id: "" },
  Management: { value: "management", id: "Management" },
  "Information Technology": { value: "information-technology", id: "Information_Technology" },
  "Arts and Humanities": { value: "arts-and-humanities", id: "Arts_and_Humanities" },
  Commerce: { value: "commerce", id: "Commerce" },
  "media & Journalism": { value: "media-journalism", id: "media_and_Journalism" },
  Career: { value: "career", id: "Career" },
};

const TAGS = {
  All: "all",
  Latest: "Latest",
  Recommended: "Recommended",
  Most_Viewed: "Most viewed",
  Featured: "Featured",
  Popular: "Popular",
};

function getKeyByURL(value) {
  for (const [key, obj] of Object.entries(CATEGORY)) {
    if (obj.value === value) {
      return key;
    }
  }
  return null; // Return null if the value is not found
}

const categoryUrlExists = (value) => {
  return (
    !!Object.values(CATEGORY).filter((item) => item.value.toUpperCase() === value.toUpperCase())
      .length || value.startsWith("page-")
  );
};

const parseUrlPath = (value) => value.split("-").join(" ");

const getYearListArray = () => {
  const currentYear = new Date().getFullYear();

  let yearList = ["all"];

  for (let i = Number(currentYear); i > 2022; i--) {
    yearList.push(i);
  }

  return yearList;
};

const getGQLParams = ({ year = "all", page = 1, tag = "all", category = "all" }) => {
  const paramsObj = {
    filters: {
      Enabled: { eq: true },
    },
    pagination: { pageSize: 12, page },
  };

  if (category !== "all") {
    paramsObj["filters"]["Categories"] = { contains: getKeyByURL(category) };
  }

  if (tag !== "all") {
    paramsObj["filters"]["Tags"] = {
      contains: TAGS[tag],
    };
  }

  if (year !== "all") {
    paramsObj["filters"]["publishedAt"] = {
      between: [ year + "-01-01T00:00:00.000Z", year + "-12-31T23:59:59.999Z"],
    };
  }
  
  return paramsObj;
};

export {
  CATEGORY,
  TAGS,
  getKeyByURL,
  parseUrlPath,
  getYearListArray,
  getGQLParams,
  categoryUrlExists,
};
